






import Vue from 'vue'
import { AdditionalField } from '@/model/additional-fields/AdditionalField'
import { AdditionalFieldItem } from '@/model/additional-fields/AdditionalFieldItem'

interface ComponentData {
  value: number | null
}

export default Vue.extend({
  name: 'AdditionalFieldsNumber',

  props: {
    item: {
      type: Object as () => AdditionalField
    }
  },

  data (): ComponentData {
    return {
      value: null
    }
  },

  watch: {},

  methods: {
    onValueChange (value: number): void {
      const payload: AdditionalFieldItem = {
        parentType: this.item.type,
        componentId: this.item.componentId,
        value: value.toString(),
        designation: '',
        id: 0,
        groupId: this.item.groupId,
        project: this.item.project
      }
      this.$emit('onValueChange', payload)
    }
  },

  created () {
    if(this.item) {
      this.value = parseInt(this.item.value)
    }
  }

})
